import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { CREATION_MESSAGES, LICENSE_OUTCOME } from './licenseOutcomeMessages';

const SuccessWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 768px;
  margin: 0 auto;
  padding: 30px 20px;
  text-align: center;
`;

const CreatedLine = styled.p`
  color: #4caf50;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;

  svg {
    margin-right: 8px;
  }
`;

const MessageText = styled.h1`
  color: #ffbb0f;
  font-size: 20px;
  line-height: 1.5;
  margin: 0;
`;

const Success = ({ outcome }) => {
  const message =
    CREATION_MESSAGES[outcome] || CREATION_MESSAGES[LICENSE_OUTCOME.NO_LICENSE];

  return (
    <SuccessWrap>
      <CreatedLine>
        <FontAwesomeIcon icon={faCheckCircle} />
        Usuario creado.
      </CreatedLine>
      <MessageText>{message}</MessageText>
    </SuccessWrap>
  );
};

export default Success;
